module.exports = __webpack_public_path__ + "static/media/400282_02.94224ed2.png";